import * as React from 'react'
import { ProgressItemProps } from './typings'

export const MiddleProgressNode: React.FC<ProgressItemProps> = (
  props: ProgressItemProps,
) => {
  const { color = '#18325A', height = 33, transitionTime = 0.5 } = props
  const width = props.width ? Math.ceil(props.width) : 100
  const midY: number = Math.ceil(height / 2)

  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      enableBackground={`new 0 0 ${width} ${height}`}
      xmlSpace="preserve"
    >
      <polygon
        style={{
          fill: color,
          transition: `fill ${transitionTime}s`,
        }}
        points={`0,0 ${midY},${midY} 0,${height} ${
          width - midY
        },${height} ${width},${midY} ${width - midY},0`}
      />
    </svg>
  )
}
MiddleProgressNode.displayName = 'MiddleProgressNode'
